var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Form, Image, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { EllipsisOutlined } from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';
import Input from '@fp-suite/core-ui/src/components/Input';
import Table from '@fp-suite/core-ui/src/components/Table';
import Button from '@fp-suite/core-ui/src/components/Button';
import dummy_img from '../images/dummy_img.svg';
import { getListOfPickRuns, searchPickRunId, getPickRunDetails, userSelector } from '../redux/authSlice';
import MainHeading from './MainHeading';
import LookUp from '../components/LookUp';
import { AiOutlineFilter } from 'react-icons/ai';
var FilterSearchBar = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
    return (_jsx("div", __assign({ style: { padding: 8 } }, { children: _jsxs("div", { children: [_jsx(Input, { title: '', placeholder: "Search", value: selectedKeys[0], onChange: function (e) { return setSelectedKeys(e.target.value ? [e.target.value] : []); }, onKeyDown: function (e) {
                        if (e.key === 'Enter') {
                            confirm();
                        }
                    }, onBlur: confirm }, void 0), _jsxs("div", __assign({ className: 'mt-3 flex flex-row items-center justify-between' }, { children: [_jsx("button", __assign({ onClick: clearFilters, className: 'px-5 text-xs sm:px-3 sm:text-sm bg-transparent focus:outline-none border border-black text-black font-semibold py-1 rounded-lg' }, { children: "Reset" }), void 0), _jsx("button", __assign({ onClick: function () {
                                document
                                    .getElementsByClassName('ant-dropdown')[0]
                                    .classList.add('ant-dropdown-hidden');
                                confirm();
                            }, className: 'px-5 text-xs sm:px-3 sm:text-sm bg-primary focus:outline-none border text-white font-semibold py-1 rounded-lg' }, { children: "Search" }), void 0)] }), void 0)] }, void 0) }), void 0));
};
var PickRuns = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var setIsLoading = _a.setIsLoading, queryString = _a.queryString;
    var t = useTranslation().t;
    var organizationsList = useSelector(userSelector).organizationsList;
    var pickRunForm = Form.useForm()[0];
    var dispatch = useDispatch();
    var history = useHistory();
    var _h = useState(true), showOpenOrders = _h[0], setShowOpenOrders = _h[1];
    var _j = useState(true), showAssignedOrders = _j[0], setShowAssignedOrders = _j[1];
    var _k = useState(false), showAllOrders = _k[0], setShowAllOrders = _k[1];
    var _l = useState('bulkpick'), currentActiveSubscreen = _l[0], setCurrentActiveSubscreen = _l[1];
    // State variables for data
    var _m = useState([]), openOrdersData = _m[0], setOpenOrdersData = _m[1];
    var _o = useState([]), completedOrdersData = _o[0], setCompletedOrdersData = _o[1];
    var _p = useState([]), allUsersOpenData = _p[0], setAllUsersOpenData = _p[1];
    var _q = useState([]), allUsersCompletedData = _q[0], setAllUsersCompletedData = _q[1];
    // Pagination and record counts
    var _r = useState(''), openMaxPageIndex = _r[0], setOpenMaxPageIndex = _r[1];
    var _s = useState(''), completedMaxPageIndex = _s[0], setCompletedMaxPageIndex = _s[1];
    var _t = useState(''), allUsersOpenMaxPageIndex = _t[0], setAllUsersOpenMaxPageIndex = _t[1]; // NEW STATE
    var _u = useState(''), allUsersCompletedMaxPageIndex = _u[0], setAllUsersCompletedMaxPageIndex = _u[1]; // NEW STATE
    var _v = useState(''), openRecordCount = _v[0], setOpenRecordCount = _v[1];
    var _w = useState(''), completedRecordCount = _w[0], setCompletedRecordCount = _w[1];
    var _x = useState(''), allUsersOpenRecordCount = _x[0], setAllUsersOpenRecordCount = _x[1];
    var _y = useState(''), allUsersCompletedRecordCount = _y[0], setAllUsersCompletedRecordCount = _y[1];
    var _z = useState(false), isLookUpVisible = _z[0], setLookUpVisible = _z[1];
    var _0 = useState(''), pickRunErrorMsgText = _0[0], setPickRunErrorMsgText = _0[1];
    var _1 = useState(false), scannedPickRunIdIncorrect = _1[0], setScannedPickRunIdIncorrect = _1[1];
    var _2 = useState(), pickRunDetails = _2[0], setPickRunDetails = _2[1];
    var _3 = useState(true), setContinueBtnDisabled = _3[1];
    var _4 = useState(''), pickRunId = _4[0], setPickRunId = _4[1];
    var _5 = useState({
        openAssigned: { filteredInfo: {}, sortedInfo: {}, activeAppliedFilters: '', sortData: '' },
        openAll: { filteredInfo: {}, sortedInfo: {}, activeAppliedFilters: '', sortData: '' },
        completedAssigned: { filteredInfo: {}, sortedInfo: {}, activeAppliedFilters: '', sortData: '' },
        completedAll: { filteredInfo: {}, sortedInfo: {}, activeAppliedFilters: '', sortData: '' }
    }), tabStates = _5[0], setTabStates = _5[1];
    var _6 = useState({}), filteredInfo = _6[0], setFilteredInfo = _6[1];
    var _7 = useState(''), activeAppliedFilters = _7[0], setActiveAppliedFilters = _7[1];
    var _8 = useState(''), sortData = _8[0], setSortData = _8[1];
    var _9 = useState({}), sortedInfo = _9[0], setSortedInfo = _9[1];
    var _10 = useState(false), resetInputField = _10[0], setResetInputField = _10[1];
    var _11 = useState(1), showOpenOrderCurrIndex = _11[0], setShowOpenOrderCurrIndex = _11[1];
    var _12 = useState(1), showCompletedOrderCurrIndex = _12[0], setShowCompletedOrderCurrIndex = _12[1];
    var _13 = useState(1), showAllOrderCurrIndex = _13[0], setShowAllOrderCurrIndex = _13[1];
    var _14 = useState(1), showAllOrderCompletedCurrIndex = _14[0], setShowAllOrderCompletedCurrIndex = _14[1];
    var statusFilters = [];
    var pickRunTypeFilter = [];
    statusFilters.push({
        text: 'In Progress',
        value: 'PrInProgress'
    }, {
        text: 'Ready',
        value: 'PrReady'
    });
    pickRunTypeFilter.push({
        text: 'Order Level',
        value: 'PrtOrderLevel'
    }, {
        text: 'Bulk Single',
        value: 'PrtBulkSingle'
    }, {
        text: 'Bulk Pick',
        value: 'PrtBulkPick'
    });
    var isMobileDevice = useMediaQuery({
        query: '(max-device-width: 640px)'
    });
    var isMediumDevice = useMediaQuery({
        query: '(max-device-width: 768px)'
    });
    var isLargeDevice = useMediaQuery({
        query: '(min-device-width: 1024px)'
    });
    var getTabKey = function (open, all) {
        if (open === void 0) { open = showOpenOrders; }
        if (all === void 0) { all = showAllOrders; }
        if (open && !all)
            return 'openAssigned';
        if (open && all)
            return 'openAll';
        if (!open && !all)
            return 'completedAssigned';
        if (!open && all)
            return 'completedAll';
    };
    var clearCurrentTabFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentKey, currentSort;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentKey = getTabKey();
                    currentSort = tabStates[currentKey].sortData;
                    setTabStates(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[currentKey] = __assign(__assign({}, prev[currentKey]), { filteredInfo: {}, activeAppliedFilters: '' }), _a)));
                    });
                    setFilteredInfo({});
                    setActiveAppliedFilters('');
                    return [4 /*yield*/, nextSetOfProds(0, currentSort, '', true)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var clearCurrentTabSorters = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentKey, currentFilters;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentKey = getTabKey();
                    currentFilters = tabStates[currentKey].activeAppliedFilters;
                    setTabStates(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[currentKey] = __assign(__assign({}, prev[currentKey]), { sortedInfo: {}, sortData: '' }), _a)));
                    });
                    setSortedInfo({});
                    setSortData('');
                    return [4 /*yield*/, nextSetOfProds(0, '', currentFilters, true)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onPickRunIdSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    event.target.blur();
                    pickRunForm.setFieldsValue({
                        scanPickRunId: ''
                    });
                    return [4 /*yield*/, dispatch(searchPickRunId({
                            pickRunId: pickRunId,
                            setPickRunErrorMsgText: setPickRunErrorMsgText,
                            setScannedPickRunIdIncorrect: setScannedPickRunIdIncorrect,
                            setPickRunDetails: setPickRunDetails,
                            setContinueBtnDisabled: setContinueBtnDisabled,
                            setLookUpVisible: setLookUpVisible
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    setScannedPickRunIdIncorrect(false);
                    setPickRunId(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    function onChange(pagination, filters, sorter) {
        var _a;
        var _b;
        var appliedFilters = '';
        if (filters.pickRunId) {
            if (!appliedFilters) {
                appliedFilters += "pickRunId=" + filters.pickRunId;
            }
            else {
                appliedFilters += "&pickRunId=" + filters.pickRunId;
            }
        }
        if (filters.pickRunTypeId) {
            if (!appliedFilters) {
                appliedFilters += "pickRunTypeId=" + filters.pickRunTypeId;
            }
            else {
                appliedFilters += "&pickRunTypeId=" + filters.pickRunTypeId;
            }
        }
        if (filters.statusId) {
            if (!appliedFilters) {
                appliedFilters += "statusId=" + filters.statusId;
            }
            else {
                appliedFilters += "&statusId=" + filters.statusId;
            }
        }
        if (filters.cartId) {
            if (!appliedFilters) {
                appliedFilters += "cartId=" + (filters === null || filters === void 0 ? void 0 : filters.cartId);
            }
            else {
                appliedFilters += "&cartId=" + (filters === null || filters === void 0 ? void 0 : filters.cartId);
            }
        }
        if (filters.dropOffLocationSeqId) {
            if (!appliedFilters) {
                appliedFilters += "dropOffLocationSeqId=" + (filters === null || filters === void 0 ? void 0 : filters.dropOffLocationSeqId);
            }
            else {
                appliedFilters += "&dropOffLocationSeqId=" + (filters === null || filters === void 0 ? void 0 : filters.dropOffLocationSeqId);
            }
        }
        setFilteredInfo(filters);
        setActiveAppliedFilters(appliedFilters);
        var outputStr = '';
        setSortData('');
        if (((_b = Object.keys(sorter)) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            setSortedInfo((_a = {},
                _a[sorter === null || sorter === void 0 ? void 0 : sorter.field] = sorter === null || sorter === void 0 ? void 0 : sorter.field,
                _a[(sorter === null || sorter === void 0 ? void 0 : sorter.field) + "Type"] = sorter === null || sorter === void 0 ? void 0 : sorter.order,
                _a));
            if (sorter.order === 'ascend') {
                outputStr = "" + sorter.field;
            }
            else if (sorter.order === 'descend') {
                outputStr = "-" + sorter.field;
            }
        }
        if (Array.isArray(sorter)) {
            var modifiedObj_1 = {};
            sorter.forEach(function (item) {
                var _a;
                modifiedObj_1 = __assign(__assign({}, modifiedObj_1), (_a = {}, _a[item === null || item === void 0 ? void 0 : item.field] = item === null || item === void 0 ? void 0 : item.field, _a[(item === null || item === void 0 ? void 0 : item.field) + "Type"] = item === null || item === void 0 ? void 0 : item.order, _a));
                if (item.order === 'ascend') {
                    if (outputStr) {
                        if (!(outputStr === null || outputStr === void 0 ? void 0 : outputStr.includes(item.field))) {
                            outputStr += "," + item.field;
                        }
                    }
                    else {
                        outputStr = item.field;
                    }
                }
                else {
                    if (outputStr) {
                        if (!(outputStr === null || outputStr === void 0 ? void 0 : outputStr.includes(item.field))) {
                            outputStr += ",-" + item.field;
                        }
                    }
                    else {
                        outputStr = "-" + item.field;
                    }
                }
            });
            setSortedInfo(modifiedObj_1);
        }
        setSortData(function (prev) {
            if (prev) {
                return prev + ("," + outputStr);
            }
            else {
                return outputStr;
            }
        });
        var prevOrderListingValue = {
            orderByFields: outputStr,
            appliedFilters: appliedFilters,
            sortedInfo: sortedInfo,
            filteredInfo: filters
        };
        localStorage.setItem('prevAppliedFilter', JSON.stringify(prevOrderListingValue));
        if (appliedFilters) {
            nextSetOfProds(0, outputStr, appliedFilters, true);
        }
        else {
            nextSetOfProds(0, outputStr, '', true);
        }
        var currentKey = getTabKey();
        setTabStates(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[currentKey] = {
                filteredInfo: filters,
                sortedInfo: sortedInfo,
                activeAppliedFilters: appliedFilters,
                sortData: outputStr
            }, _a)));
        });
    }
    var openOrdersColumns = [
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Picking ID') }), void 0) }), void 0)),
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (_jsx(FilterSearchBar, { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters }, void 0));
            },
            filterIcon: function () {
                return filteredInfo.pickRunId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.pickRunId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.pickRunId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.pickRunId === 'number') {
                        return a.pickRunId - b.pickRunId;
                    }
                    else {
                        return (_a = a.pickRunId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.pickRunId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunId) === 'pickRunId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunIdType),
            render: function (pickRunId) { return (_jsx("h1", __assign({ className: 'cursor-pointer underline text-secondary-text font-medium text-sm', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsLoading(true);
                                return [4 /*yield*/, dispatch(searchPickRunId({
                                        pickRunId: pickRunId,
                                        setPickRunErrorMsgText: setPickRunErrorMsgText,
                                        setScannedPickRunIdIncorrect: setScannedPickRunIdIncorrect,
                                        setPickRunDetails: setPickRunDetails,
                                        setContinueBtnDisabled: setContinueBtnDisabled,
                                        setLookUpVisible: setLookUpVisible
                                    }))];
                            case 1:
                                _a.sent();
                                setIsLoading(false);
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: pickRunId }), void 0)); },
            dataIndex: 'pickRunId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: "Type" }), void 0) }), void 0)),
            filters: pickRunTypeFilter,
            filterIcon: function () {
                return filteredInfo.pickRunTypeId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.pickRunTypeId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.pickRunTypeId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.pickRunTypeId === 'number') {
                        return a.pickRunTypeId - b.pickRunTypeId;
                    }
                    else {
                        return (_a = a.pickRunTypeId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.pickRunTypeId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunTypeId) === 'pickRunTypeId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunTypeIdType),
            render: function (pickRunTypeId) { return (_jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: pickRunTypeId === 'PrtSingle'
                    ? 'Single'
                    : pickRunTypeId === 'PrtMulti'
                        ? 'Multi'
                        : pickRunTypeId === 'PrtOrderLevel'
                            ? 'Order Level'
                            : pickRunTypeId === 'PrtBulkSingle'
                                ? 'Bulk Single'
                                : pickRunTypeId === 'PrtBulkPick'
                                    ? 'Bulk Pick'
                                    : '' }), void 0)); },
            dataIndex: 'pickRunTypeId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Status') }), void 0) }), void 0)),
            filters: statusFilters,
            filterIcon: function () {
                return filteredInfo.statusId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.statusId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.statusId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.statusId === 'number') {
                        return a.statusId - b.statusId;
                    }
                    else {
                        return (_a = a.statusId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.statusId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.statusId) === 'statusId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.statusIdType),
            render: function (statusId) { return (_jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: statusId === 'PrInProgress'
                    ? t('In Progress')
                    : statusId === 'PrReady'
                        ? t('Ready')
                        : '' }), void 0)); },
            dataIndex: 'statusId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Cart ID') }), void 0) }), void 0)),
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (_jsx(FilterSearchBar, { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters }, void 0));
            },
            filterIcon: function () {
                return filteredInfo.cartId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.cartId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.cartId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.cartId === 'number') {
                        return a.cartId - b.cartId;
                    }
                    else {
                        return (_a = a.cartId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.cartId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.cartId) === 'cartId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.cartIdType),
            render: function (cartId) { return _jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: cartId }), void 0); },
            dataIndex: 'cartId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Start Date') }), void 0) }), void 0)),
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.startDate === 'number') {
                        return a.startDate - b.startDate;
                    }
                    else {
                        return (_a = a.startDate) === null || _a === void 0 ? void 0 : _a.localeCompare(b.startDate);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.startDate) === 'startDate' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.startDateType),
            render: function (startDate) { return (_jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: startDate ? new Date(startDate).toISOString().slice(0, 10) : '' }), void 0)); },
            dataIndex: 'startDate'
        }
    ];
    var completedOrdersColumns = [
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Picking ID') }), void 0) }), void 0)),
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (_jsx(FilterSearchBar, { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters }, void 0));
            },
            filterIcon: function () {
                return filteredInfo.pickRunId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.pickRunId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.pickRunId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.pickRunId === 'number') {
                        return a.pickRunId - b.pickRunId;
                    }
                    else {
                        return (_a = a.pickRunId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.pickRunId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunId) === 'pickRunId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunIdType),
            render: function (pickRunId) { return (_jsx("h1", __assign({ className: 'cursor-pointer underline text-secondary-text font-medium text-sm', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsLoading(true);
                                return [4 /*yield*/, dispatch(searchPickRunId({
                                        pickRunId: pickRunId,
                                        setPickRunErrorMsgText: setPickRunErrorMsgText,
                                        setScannedPickRunIdIncorrect: setScannedPickRunIdIncorrect,
                                        setPickRunDetails: setPickRunDetails,
                                        setContinueBtnDisabled: setContinueBtnDisabled,
                                        setLookUpVisible: setLookUpVisible
                                    }))];
                            case 1:
                                _a.sent();
                                setIsLoading(false);
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: pickRunId }), void 0)); },
            dataIndex: 'pickRunId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: "Type" }), void 0) }), void 0)),
            filters: pickRunTypeFilter,
            filterIcon: function () {
                return filteredInfo.pickRunTypeId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.pickRunTypeId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.pickRunTypeId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.pickRunTypeId === 'number') {
                        return a.pickRunTypeId - b.pickRunTypeId;
                    }
                    else {
                        return (_a = a.pickRunTypeId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.pickRunTypeId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunTypeId) === 'pickRunTypeId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.pickRunTypeIdType),
            render: function (pickRunTypeId) { return (_jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: pickRunTypeId === 'PrtSingle'
                    ? t('Single')
                    : pickRunTypeId === 'PrtMulti'
                        ? t('Multi')
                        : pickRunTypeId === 'PrtOrderLevel'
                            ? t('Order Level')
                            : pickRunTypeId === 'PrtBulkSingle'
                                ? t('Bulk Single')
                                : pickRunTypeId === 'PrtBulkPick'
                                    ? t('Bulk Pick')
                                    : '' }), void 0)); },
            dataIndex: 'pickRunTypeId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Cart ID') }), void 0) }), void 0)),
            render: function (cartId) { return _jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: cartId }), void 0); },
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (_jsx(FilterSearchBar, { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters }, void 0));
            },
            filterIcon: function () {
                return filteredInfo.cartId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.cartId) || null,
            onFilter: function (value, record) { var _a; return (_a = record === null || record === void 0 ? void 0 : record.cartId) === null || _a === void 0 ? void 0 : _a.includes(value); },
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.cartId === 'number') {
                        return a.cartId - b.cartId;
                    }
                    else {
                        return (_a = a.cartId) === null || _a === void 0 ? void 0 : _a.localeCompare(b.cartId);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.cartId) === 'cartId' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.cartIdType),
            dataIndex: 'cartId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Drop Off Location') }), void 0) }), void 0)),
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (_jsx(FilterSearchBar, { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters }, void 0));
            },
            filterIcon: function () {
                return filteredInfo.dropOffLocationSeqId ? (_jsx(AiOutlineFilter, { size: 17, color: '#093479' }, void 0)) : (_jsx(AiOutlineFilter, { size: 17 }, void 0));
            },
            filteredValue: (filteredInfo === null || filteredInfo === void 0 ? void 0 : filteredInfo.dropOffLocationSeqId) || null,
            render: function (dropOffLocationSeqId) {
                return _jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: dropOffLocationSeqId }), void 0);
            },
            dataIndex: 'dropOffLocationSeqId'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: "Start Date" }), void 0) }), void 0)),
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.startDate === 'number') {
                        return a.startDate - b.startDate;
                    }
                    else {
                        return (_a = a.startDate) === null || _a === void 0 ? void 0 : _a.localeCompare(b.startDate);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.startDate) === 'startDate' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.startDateType),
            render: function (startDate) { return (_jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: startDate ? new Date(startDate).toISOString().slice(0, 10) : '' }), void 0)); },
            dataIndex: 'startDate'
        },
        {
            title: (_jsx("div", __assign({ className: 'flex items-center relative h-5' }, { children: _jsx("p", __assign({ className: 'mr-1' }, { children: t('End Date') }), void 0) }), void 0)),
            sorter: {
                compare: function (a, b) {
                    var _a;
                    if (typeof a.endDate === 'number') {
                        return a.endDate - b.endDate;
                    }
                    else {
                        return (_a = a.endDate) === null || _a === void 0 ? void 0 : _a.localeCompare(b.endDate);
                    }
                },
                multiple: 1
            },
            sortOrder: (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.endDate) === 'endDate' && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.endDateType),
            render: function (endDate) { return (_jsx("h1", __assign({ className: 'font-medium text-sm' }, { children: endDate ? new Date(endDate).toISOString().slice(0, 10) : '' }), void 0)); },
            dataIndex: 'endDate'
        }
    ];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, dispatch(getListOfPickRuns({
                                setPickRunsList: setOpenOrdersData,
                                statusId: 'PrInProgress,PrReady',
                                setMaxPageIndex: setOpenMaxPageIndex,
                                setRecordCount: setOpenRecordCount,
                                pageIndex: 0
                            }))];
                    case 1:
                        _a.sent();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        return function () {
            setIsLoading(false);
        };
    }, []); // eslint-disable-line
    var nextSetOfProds = function (pageIndex, orderByFields, appliedFilters, resetFields) { return __awaiter(void 0, void 0, void 0, function () {
        var currentKey, setMaxIndexFunc, setRecordCountFunc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    localStorage.setItem('currPageIndex', pageIndex);
                    if (showOpenOrders) {
                        if (showAllOrders) {
                            setShowAllOrderCurrIndex(pageIndex + 1);
                        }
                        else {
                            setShowOpenOrderCurrIndex(pageIndex + 1);
                        }
                    }
                    else if (showAllOrders) {
                        setShowAllOrderCompletedCurrIndex(pageIndex + 1);
                    }
                    else {
                        setShowCompletedOrderCurrIndex(pageIndex + 1);
                    }
                    currentKey = getTabKey();
                    if (showOpenOrders) {
                        if (showAllOrders) {
                            setMaxIndexFunc = setAllUsersOpenMaxPageIndex;
                            setRecordCountFunc = setAllUsersOpenRecordCount;
                        }
                        else {
                            setMaxIndexFunc = setOpenMaxPageIndex;
                            setRecordCountFunc = setOpenRecordCount;
                        }
                    }
                    else {
                        if (showAllOrders) {
                            setMaxIndexFunc = setAllUsersCompletedMaxPageIndex;
                            setRecordCountFunc = setAllUsersCompletedRecordCount;
                        }
                        else {
                            setMaxIndexFunc = setCompletedMaxPageIndex;
                            setRecordCountFunc = setCompletedRecordCount;
                        }
                    }
                    if (resetFields) {
                        setResetInputField(true);
                    }
                    else {
                        setResetInputField(false);
                    }
                    return [4 /*yield*/, dispatch(getListOfPickRuns(__assign(__assign({ setPickRunsList: showOpenOrders
                                ? showAllOrders
                                    ? setAllUsersOpenData
                                    : setOpenOrdersData
                                : showAllOrders
                                    ? setAllUsersCompletedData
                                    : setCompletedOrdersData, setMaxPageIndex: setMaxIndexFunc, setRecordCount: setRecordCountFunc, pageIndex: pageIndex, orderByFields: orderByFields, allUsers: showAllOrders, queryString: queryString }, (!(appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.includes('statusId=')) && {
                            statusId: showOpenOrders ? 'PrInProgress,PrReady' : 'PrCompleted'
                        })), (appliedFilters
                            ? { appliedFilters: appliedFilters }
                            : { statusId: showOpenOrders ? 'PrInProgress,PrReady' : 'PrCompleted' }))))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var loadNextPickRuns = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var currentMaxPageIndex, passedIndex, currentKey, _a, tabActiveAppliedFilters, tabSortData;
        return __generator(this, function (_b) {
            if (!index || index * 1 === 0) {
                return [2 /*return*/];
            }
            if (showOpenOrders) {
                currentMaxPageIndex = showAllOrders ? allUsersOpenMaxPageIndex : openMaxPageIndex;
            }
            else {
                currentMaxPageIndex = showAllOrders ? allUsersCompletedMaxPageIndex : completedMaxPageIndex;
            }
            if (index * 1 > currentMaxPageIndex) {
                return [2 /*return*/];
            }
            passedIndex = index * 1 - 1;
            currentKey = getTabKey();
            _a = tabStates[currentKey], tabActiveAppliedFilters = _a.activeAppliedFilters, tabSortData = _a.sortData;
            nextSetOfProds(passedIndex, tabSortData, tabActiveAppliedFilters);
            return [2 /*return*/];
        });
    }); };
    var handleTabSwitch = function (newShowOpenOrders, newShowAllOrders) { return __awaiter(void 0, void 0, void 0, function () {
        var currentKey, newKey, _a, newFilteredInfo, newSortedInfo, newActiveAppliedFilters, newSortData, setMaxIndexFunc, setRecordCountFunc, setRunsList, statusIdParam;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentKey = getTabKey();
                    setTabStates(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[currentKey] = {
                            filteredInfo: filteredInfo,
                            sortedInfo: sortedInfo,
                            activeAppliedFilters: activeAppliedFilters,
                            sortData: sortData
                        }, _a)));
                    });
                    setShowOpenOrders(newShowOpenOrders);
                    setShowAllOrders(newShowAllOrders);
                    newKey = getTabKey(newShowOpenOrders, newShowAllOrders);
                    _a = tabStates[newKey], newFilteredInfo = _a.filteredInfo, newSortedInfo = _a.sortedInfo, newActiveAppliedFilters = _a.activeAppliedFilters, newSortData = _a.sortData;
                    setFilteredInfo(newFilteredInfo);
                    setSortedInfo(newSortedInfo);
                    setActiveAppliedFilters(newActiveAppliedFilters);
                    setSortData(newSortData);
                    setIsLoading(true);
                    statusIdParam = newShowOpenOrders ? 'PrInProgress,PrReady' : 'PrCompleted';
                    if (!newShowOpenOrders) return [3 /*break*/, 6];
                    if (!newShowAllOrders) return [3 /*break*/, 3];
                    console.log('allUsersOpenData', allUsersOpenData, activeAppliedFilters);
                    setMaxIndexFunc = setAllUsersOpenMaxPageIndex;
                    setRecordCountFunc = setAllUsersOpenRecordCount;
                    setRunsList = setAllUsersOpenData;
                    if (!(allUsersOpenData.length === 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getListOfPickRuns(__assign(__assign({ setPickRunsList: setRunsList, statusId: statusIdParam, setMaxPageIndex: setMaxIndexFunc, setRecordCount: setRecordCountFunc, pageIndex: 0, allUsers: true }, (newActiveAppliedFilters ? { appliedFilters: newActiveAppliedFilters } : {})), (newSortData ? { orderByFields: newSortData } : {}))))];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    setMaxIndexFunc = setOpenMaxPageIndex;
                    setRecordCountFunc = setOpenRecordCount;
                    setRunsList = setOpenOrdersData;
                    if (!(openOrdersData.length === 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(getListOfPickRuns(__assign(__assign({ setPickRunsList: setRunsList, statusId: statusIdParam, setMaxPageIndex: setMaxIndexFunc, setRecordCount: setRecordCountFunc, pageIndex: 0 }, (newActiveAppliedFilters ? { appliedFilters: newActiveAppliedFilters } : {})), (newSortData ? { orderByFields: newSortData } : {}))))];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [3 /*break*/, 11];
                case 6:
                    if (!newShowAllOrders) return [3 /*break*/, 9];
                    setMaxIndexFunc = setAllUsersCompletedMaxPageIndex;
                    setRecordCountFunc = setAllUsersCompletedRecordCount;
                    setRunsList = setAllUsersCompletedData;
                    if (!(allUsersCompletedData.length === 0)) return [3 /*break*/, 8];
                    return [4 /*yield*/, dispatch(getListOfPickRuns(__assign(__assign({ setPickRunsList: setRunsList, statusId: statusIdParam, setMaxPageIndex: setMaxIndexFunc, setRecordCount: setRecordCountFunc, pageIndex: 0, allUsers: true }, (newActiveAppliedFilters ? { appliedFilters: newActiveAppliedFilters } : {})), (newSortData ? { orderByFields: newSortData } : {}))))];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    setMaxIndexFunc = setCompletedMaxPageIndex;
                    setRecordCountFunc = setCompletedRecordCount;
                    setRunsList = setCompletedOrdersData;
                    if (!(completedOrdersData.length === 0)) return [3 /*break*/, 11];
                    return [4 /*yield*/, dispatch(getListOfPickRuns(__assign(__assign({ setPickRunsList: setRunsList, statusId: statusIdParam, setMaxPageIndex: setMaxIndexFunc, setRecordCount: setRecordCountFunc, pageIndex: 0 }, (newActiveAppliedFilters ? { appliedFilters: newActiveAppliedFilters } : {})), (newSortData ? { orderByFields: newSortData } : {}))))];
                case 10:
                    _b.sent();
                    _b.label = 11;
                case 11:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "px-4 " + (isMobileDevice ? 'sm:px-6' : 'sm:px-8') + " lg:px-20 pt-1 lg:pt-3 pb-16 h-screen w-full mx-auto" }, { children: [_jsx(LookUp, __assign({ width: isMobileDevice ? '90%' : isMediumDevice ? '70%' : isLargeDevice ? '55%' : '70%', title: t('Picking Details'), visible: isLookUpVisible, onCancel: function () { return [setLookUpVisible(false)]; } }, { children: _jsx("div", __assign({ className: 'mb-72' }, { children: (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.pickRunId) && (_jsxs("div", __assign({ className: 'mb-4' }, { children: [_jsx("div", __assign({ className: 'mb-4' }, { children: _jsxs("div", __assign({ className: 'w-full flex flex-row justify-between' }, { children: [_jsxs("div", __assign({ className: 'w-1/2' }, { children: [pickRunDetails.pickRunId && (_jsxs("div", __assign({ className: 'flex flex-row items-center my-1' }, { children: [_jsxs("h1", __assign({ className: 'font-semibold text-black text-base mr-5 w-3/5' }, { children: [t('Pick Run Id'), " #", pickRunDetails.pickRunId] }), void 0), pickRunDetails.statusId && (_jsx("div", __assign({ className: 'w-3/5' }, { children: _jsx("h1", __assign({ style: {
                                                                    backgroundColor: '#EFF2F5',
                                                                    outlineColor: '#707070',
                                                                    border: '1px solid #707070'
                                                                }, className: 'px-1.5 py-0.5 text-center tracking-wider border font-bold rounded-md w-max' }, { children: pickRunDetails.statusId === 'PrCompleted'
                                                                    ? t('Completed')
                                                                    : pickRunDetails.statusId === 'PrInProgress'
                                                                        ? t('In Progress')
                                                                        : ((_b = pickRunDetails.statusId) === null || _b === void 0 ? void 0 : _b.includes('Cancel'))
                                                                            ? t('Cancelled')
                                                                            : t('Ready') }), void 0) }), void 0))] }), void 0)), pickRunDetails.cartId && (_jsxs("div", __assign({ className: 'flex flex-row items-center my-1' }, { children: [_jsx("h1", __assign({ className: 'font-semibold text-black text-base mr-5 w-3/5' }, { children: t('Cart') }), void 0), _jsx("h1", __assign({ className: 'font-medium w-3/5' }, { children: pickRunDetails.cartId }), void 0)] }), void 0)), pickRunDetails.pickRunTypeId && (_jsxs("div", __assign({ className: 'flex flex-row items-center my-1' }, { children: [_jsx("h1", __assign({ className: 'font-semibold text-black text-base mr-5 w-3/5' }, { children: t('Picking Type') }), void 0), _jsx("h1", __assign({ className: 'font-medium w-3/5' }, { children: pickRunDetails.pickRunTypeId === 'PrtSingle'
                                                                ? t('Single')
                                                                : pickRunDetails.pickRunTypeId === 'PrtOrderLevel'
                                                                    ? t('Order Level')
                                                                    : pickRunDetails.pickRunTypeId === 'PrtBulkSingle'
                                                                        ? t('Bulk Single')
                                                                        : pickRunDetails.pickRunTypeId === 'PrtBulkPick'
                                                                            ? t('Bulk Pick')
                                                                            : '' }), void 0)] }), void 0))] }), void 0), _jsx("div", { children: Object.keys(pickRunDetails).length <= 0 ||
                                                (!((_c = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.statusId) === null || _c === void 0 ? void 0 : _c.includes('InProgress')) &&
                                                    !((_d = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.statusId) === null || _d === void 0 ? void 0 : _d.includes('Ready'))) ? null : (_jsx("div", __assign({ className: 'flex flex-row justify-end mt-4' }, { children: _jsx(Button, { buttonText: t('Continue'), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                        var loggedInUserId, nearestLocationSeqId, pickRunType;
                                                        var _a, _b, _c, _d, _e;
                                                        return __generator(this, function (_f) {
                                                            switch (_f.label) {
                                                                case 0:
                                                                    loggedInUserId = localStorage.getItem('userId');
                                                                    setIsLoading(true);
                                                                    if (!(!(pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.assignedToUserId) ||
                                                                        (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.assignedToUserId) === loggedInUserId)) return [3 /*break*/, 2];
                                                                    nearestLocationSeqId = (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) &&
                                                                        ((_a = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                                                        ((_c = (_b = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.locationSeqId)
                                                                        ? (_e = (_d = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.locationSeqId
                                                                        : '';
                                                                    pickRunType = (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.pickRunTypeId)
                                                                        ? pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.pickRunTypeId
                                                                        : '';
                                                                    return [4 /*yield*/, dispatch(getPickRunDetails({
                                                                            setErrorMsgText: setPickRunErrorMsgText,
                                                                            setScannedLocationIncorrect: setScannedPickRunIdIncorrect,
                                                                            nearestLocationSeqId: nearestLocationSeqId,
                                                                            fromLookup: true,
                                                                            history: history,
                                                                            pickRunType: pickRunType,
                                                                            setLookUpVisible: setLookUpVisible,
                                                                            fromPickRunsScreen: true
                                                                        }))];
                                                                case 1:
                                                                    _f.sent();
                                                                    return [3 /*break*/, 3];
                                                                case 2:
                                                                    notification['error']({
                                                                        message: t('Error'),
                                                                        description: t('Picking already in progress!')
                                                                    });
                                                                    setLookUpVisible(false);
                                                                    _f.label = 3;
                                                                case 3:
                                                                    setIsLoading(false);
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); } }, void 0) }), void 0)) }, void 0)] }), void 0) }), void 0), ((_e = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
                                (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items.map(function (item) {
                                    var _a, _b, _c, _d, _e;
                                    return (_jsx("div", __assign({ className: 'w-11/12 mx-auto p-2 sm:p-5 sm:px-10 lg:px-6 mb-7 rounded-xl shadow-custom-2 bg-white' }, { children: _jsxs("div", __assign({ className: 'grid grid-cols-1 gap-6 lg:grid-cols-12' }, { children: [_jsx("div", __assign({ className: 'col-span-1 lg:col-span-2' }, { children: _jsx(Image, { src: dummy_img, preview: false, width: isMobileDevice ? 40 : 50, height: isMobileDevice ? 40 : 50 }, void 0) }), void 0), _jsx("div", __assign({ className: 'col-span-1 lg:col-span-3' }, { children: _jsxs("div", __assign({ className: 'text-center lg:text-left' }, { children: [(item === null || item === void 0 ? void 0 : item.pickRunItemId) && (_jsx("p", __assign({ className: '  text-zinc-700' }, { children: item.pickRunItemId }), void 0)), (item === null || item === void 0 ? void 0 : item.productName) && (_jsx("p", __assign({ className: '  text-zinc-700' }, { children: item.productName }), void 0)), (item === null || item === void 0 ? void 0 : item.productSku) && _jsx("p", __assign({ className: '  text-zinc-700' }, { children: item.productSku }), void 0), (item === null || item === void 0 ? void 0 : item.productUpc) && _jsx("p", __assign({ className: '  text-zinc-700' }, { children: item.productUpc }), void 0), (item === null || item === void 0 ? void 0 : item.sku) && (_jsx("h4", __assign({ className: 'text-base font-bold text-zinc-700' }, { children: item.sku }), void 0)), (item === null || item === void 0 ? void 0 : item.upc) && (_jsx("h4", __assign({ className: 'text-base font-bold text-zinc-700' }, { children: item.upc }), void 0))] }), void 0) }), void 0), _jsx("div", __assign({ className: 'col-span-1 lg:col-span-5' }, { children: _jsxs("div", __assign({ className: 'gap-6 grid grid-cols-4 lg:text-left text-center' }, { children: [_jsxs("div", __assign({ className: 'col-span-2 flex flex-col items-center' }, { children: [_jsx("p", __assign({ className: 'text-xxs font-semibold text-yellow-500' }, { children: t('Picked/Total QTY') }), void 0), _jsx("p", __assign({ className: 'font-bold text-zinc-700' }, { children: ((_a = item === null || item === void 0 ? void 0 : item.pickedQuantity) !== null && _a !== void 0 ? _a : 0) + "/" + ((_b = item === null || item === void 0 ? void 0 : item.quantity) !== null && _b !== void 0 ? _b : 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'col-span-2' }, { children: [_jsx("p", __assign({ className: 'font-bold text-zinc-700' }, { children: ((_c = item === null || item === void 0 ? void 0 : item.exceptionTypeEnumId) === null || _c === void 0 ? void 0 : _c.includes('Incorrect'))
                                                                            ? 'Incorrect'
                                                                            : ((_d = item === null || item === void 0 ? void 0 : item.exceptionTypeEnumId) === null || _d === void 0 ? void 0 : _d.includes('Missing'))
                                                                                ? 'Missing'
                                                                                : ((_e = item === null || item === void 0 ? void 0 : item.exceptionTypeEnumId) === null || _e === void 0 ? void 0 : _e.includes('Damaged'))
                                                                                    ? 'Damaged'
                                                                                    : '' }), void 0), _jsx("p", { className: 'text-sm font-semibold text-zinc-700' }, void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0) }), item.pickRunItemId));
                                })), Object.keys(pickRunDetails).length <= 0 ||
                                (!((_f = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.statusId) === null || _f === void 0 ? void 0 : _f.includes('InProgress')) &&
                                    !((_g = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.statusId) === null || _g === void 0 ? void 0 : _g.includes('Ready'))) ? null : (_jsx("div", __assign({ className: 'flex flex-row justify-end mt-4' }, { children: _jsx(Button, { buttonText: t('Continue'), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var loggedInUserId, nearestLocationSeqId, pickRunType;
                                        var _a, _b, _c, _d, _e;
                                        return __generator(this, function (_f) {
                                            switch (_f.label) {
                                                case 0:
                                                    loggedInUserId = localStorage.getItem('userId');
                                                    setIsLoading(true);
                                                    if (!(!(pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.assignedToUserId) ||
                                                        (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.assignedToUserId) === loggedInUserId)) return [3 /*break*/, 2];
                                                    nearestLocationSeqId = (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) &&
                                                        ((_a = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                                        ((_c = (_b = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.locationSeqId)
                                                        ? (_e = (_d = pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.items) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.locationSeqId
                                                        : '';
                                                    pickRunType = (pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.pickRunTypeId)
                                                        ? pickRunDetails === null || pickRunDetails === void 0 ? void 0 : pickRunDetails.pickRunTypeId
                                                        : '';
                                                    return [4 /*yield*/, dispatch(getPickRunDetails({
                                                            setErrorMsgText: setPickRunErrorMsgText,
                                                            setScannedLocationIncorrect: setScannedPickRunIdIncorrect,
                                                            nearestLocationSeqId: nearestLocationSeqId,
                                                            fromLookup: true,
                                                            history: history,
                                                            pickRunType: pickRunType,
                                                            setLookUpVisible: setLookUpVisible,
                                                            fromPickRunsScreen: true
                                                        }))];
                                                case 1:
                                                    _f.sent();
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    notification['error']({
                                                        message: t('Error'),
                                                        description: t('Picking already in progress!')
                                                    });
                                                    setLookUpVisible(false);
                                                    _f.label = 3;
                                                case 3:
                                                    setIsLoading(false);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); } }, void 0) }), void 0))] }), void 0)) }), void 0) }), void 0), _jsx(MainHeading, { heading: t('Bulk Pick') }, void 0), _jsx(Form, __assign({ form: pickRunForm, className: 'w-full sm:w-4/5 md:w-3/5 lg:w-1/2 mt-6' }, { children: _jsx(Form.Item, __assign({ validateStatus: scannedPickRunIdIncorrect ? 'error' : '', help: scannedPickRunIdIncorrect && pickRunErrorMsgText, className: 'w-full', name: 'scanPickRunId' }, { children: _jsx(Input, { placeholder: '', title: t('Enter Picking To LookUp'), onKeyDown: onPickRunIdSubmit, value: pickRunId, onChange: function (e) { return setPickRunId(e.target.value); }, autoFocus: true }, void 0) }), void 0) }), void 0), _jsx(Dropdown, __assign({ overlay: _jsxs(Menu, __assign({ onClick: function (val) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (val.key === 'ClearFilter') {
                                clearCurrentTabFilters();
                            }
                            else {
                                clearCurrentTabSorters();
                            }
                            return [2 /*return*/];
                        });
                    }); } }, { children: [_jsx(Menu.Item, { children: "Clear Filters" }, 'ClearFilter'), _jsx(Menu.Item, { children: "Clear Sorter" }, 'ClearSorter')] }), void 0), trigger: ['click'], placement: 'topLeft' }, { children: _jsx(EllipsisOutlined, { style: { fontSize: 18 } }, void 0) }), void 0), _jsxs("div", __assign({ className: 'md:flex flex-row items-center gap-x-6' }, { children: [_jsxs("div", __assign({ className: 'flex flex-row items-center my-6' }, { children: [_jsx("div", __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!!showOpenOrders) return [3 /*break*/, 2];
                                                return [4 /*yield*/, handleTabSwitch(true, showAllOrders)];
                                            case 1:
                                                _a.sent();
                                                _a.label = 2;
                                            case 2: return [2 /*return*/];
                                        }
                                    });
                                }); }, className: "cursor-pointer border-2 " + (showOpenOrders ? 'border-primary' : 'border-gray-400 border-r-0') + " p-3 rounded-r-none rounded-l-md w-28" }, { children: _jsx("h1", __assign({ className: "text-center font-semibold " + (showOpenOrders ? 'text-primary' : 'text-gray-400') }, { children: "Open" }), void 0) }), void 0), _jsx("div", __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!showOpenOrders) return [3 /*break*/, 2];
                                                return [4 /*yield*/, handleTabSwitch(false, showAllOrders)];
                                            case 1:
                                                _a.sent();
                                                _a.label = 2;
                                            case 2: return [2 /*return*/];
                                        }
                                    });
                                }); }, className: "cursor-pointer border-2 " + (!showOpenOrders ? 'border-primary' : 'border-gray-400 border-l-0') + " p-3 rounded-l-none rounded-r-md w-28" }, { children: _jsx("h1", __assign({ className: "text-center font-semibold " + (!showOpenOrders ? 'text-primary' : 'text-gray-400') }, { children: "Completed" }), void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex flex-row items-center my-6' }, { children: [_jsx("div", __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!showAllOrders) return [3 /*break*/, 2];
                                                return [4 /*yield*/, handleTabSwitch(showOpenOrders, false)];
                                            case 1:
                                                _a.sent();
                                                _a.label = 2;
                                            case 2: return [2 /*return*/];
                                        }
                                    });
                                }); }, className: "cursor-pointer border-2 " + (!showAllOrders ? 'border-primary' : 'border-gray-400 border-r-0') + " p-3 rounded-r-none rounded-l-md w-28" }, { children: _jsx("h1", __assign({ className: "text-center font-semibold " + (!showAllOrders ? 'text-primary' : 'text-gray-400') }, { children: "Assigned" }), void 0) }), void 0), _jsx("div", __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                console.log('index,maxPageIndex', openMaxPageIndex);
                                                if (!!showAllOrders) return [3 /*break*/, 2];
                                                return [4 /*yield*/, handleTabSwitch(showOpenOrders, true)];
                                            case 1:
                                                _a.sent();
                                                _a.label = 2;
                                            case 2: return [2 /*return*/];
                                        }
                                    });
                                }); }, className: "cursor-pointer border-2 " + (showAllOrders ? 'border-primary' : 'border-gray-400 border-l-0') + " p-3 rounded-l-none rounded-r-md w-28" }, { children: _jsx("h1", __assign({ className: "text-center font-semibold " + (showAllOrders ? 'text-primary' : 'text-gray-400') }, { children: "All" }), void 0) }), void 0)] }), void 0)] }), void 0), (function () {
                var dataSource = [];
                var columns = [];
                var recordCount = 0;
                if (showOpenOrders) {
                    columns = openOrdersColumns;
                    if (showAllOrders) {
                        dataSource = allUsersOpenData;
                        recordCount = allUsersOpenRecordCount;
                    }
                    else {
                        dataSource = openOrdersData;
                        recordCount = openRecordCount;
                    }
                }
                else {
                    columns = completedOrdersColumns;
                    if (showAllOrders) {
                        dataSource = allUsersCompletedData;
                        recordCount = allUsersCompletedRecordCount;
                    }
                    else {
                        dataSource = completedOrdersData;
                        recordCount = completedRecordCount;
                    }
                }
                return (_jsx("div", __assign({ className: 'bg-white p-5 pb-2 rounded-lg shadow-sm' }, { children: _jsx(Table, { columns: columns, dataSource: dataSource, isPaginated: true, isServerRendered: recordCount ? true : false, loadNextProds: loadNextPickRuns, recordCount: recordCount, onChange: onChange, resetInputField: resetInputField, activeTab: showOpenOrders
                            ? showAllOrders
                                ? 'All'
                                : 'open'
                            : showAllOrders
                                ? 'completedAll'
                                : 'completed', currIndex: showOpenOrders
                            ? showAllOrders
                                ? showAllOrderCurrIndex
                                : showOpenOrderCurrIndex
                            : showAllOrders
                                ? showAllOrderCompletedCurrIndex
                                : showCompletedOrderCurrIndex }, 'pickRunId') }), void 0));
            })()] }), void 0));
};
export default PickRuns;
